const adsliderDatalayer = {
    init() {
        // send list event for most viewed ad
        if ($('.details-page-view-history__tab-active').attr('data-id') === 'vifMostViewed') {
            adsliderDatalayer.sendListEvent(
                'Suositut',
                $('#mostViewedAdDatalayerJson').data('datalayer-list-location'),
                $('#mostViewedAdDatalayerJson').data('datalayer-json') || ''
            );
        }

        // send list event for previous viewed ad
        if ($('.details-page-view-history__tab-active').attr('data-id') === 'vifPrevViewed') {
            adsliderDatalayer.sendListEvent(
                'Aiemmin katsotut',
                $('#previouslyViewedAdDatalayerJson').data('datalayer-list-location'),
                $('#previouslyViewedAdDatalayerJson').data('datalayer-json') || ''
            );
        }

        // send list event for latest viewed ad
        adsliderDatalayer.sendListEvent(
            'Uusimmat',
            $('#latestAdDatalayerJson').data('datalayer-list-location'),
            $('#latestAdDatalayerJson').data('datalayer-json') || ''
        );

        // send list event for most popular ad
        adsliderDatalayer.sendListEvent(
            'Suosituimmat',
            $('#mostPopularAdDatalayerJson').data('datalayer-list-location'),
            $('#mostPopularAdDatalayerJson').data('datalayer-json') || ''
        );

        // send list event for article makemodel ad
        adsliderDatalayer.sendListEvent(
            'Myydään',
            $('#articleMakeModelAdDatalayerJson').data('datalayer-list-location'),
            $('#articleMakeModelAdDatalayerJson').data('datalayer-json') || ''
        );
    },
    sendListEvent(listName, listLocation, datalayerData) {
        if (datalayerData) {
            // send product list datalayer event
            commonUtils.dataLayer.productListImpressionDataLayerEvent(datalayerData, listLocation, listName);
        }
    },
};

$(function () {
    // Send homepage and VIF active adslider datalayer product list event
    adsliderDatalayer.init();

    // Send datalayer product list event on click of previous viewed ad tab in VIF
    $('body').on('click', '#prevViewedAdTab', function () {
        adsliderDatalayer.sendListEvent(
            'Aiemmin katsotut',
            $('#previouslyViewedAdDatalayerJson').data('datalayer-list-location'),
            $('#previouslyViewedAdDatalayerJson').data('datalayer-json') || ''
        );
    });

    // Send datalayer product list event on click of most viewed ad tab in VIF
    $('body').on('click', '#mostViewedAdTab', function () {
        adsliderDatalayer.sendListEvent(
            'Suositut',
            $('#mostViewedAdDatalayerJson').data('datalayer-list-location'),
            $('#mostViewedAdDatalayerJson').data('datalayer-json') || ''
        );
    });

    // Send datalayer click event on click of slider ad
    $('body').on('click', '.adSliderDatalayer', function () {
        let datalayerData = $(this).data('datalayer');
        if (datalayerData) {
            let listLocation = $(this).data('datalayer-list-location');
            let listName = $(this).data('datalayer-list-name');
            commonUtils.dataLayer.productListClickDataLayerEvent(datalayerData, listLocation, listName);
        }
    });
});
